// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"f5e6e683","151":"f4ed8cb8","206":"f5e6e683","472":"5f186c6d","508":"f4ed8cb8","565":"2e89208a","615":"f5e6e683","658":"f4ed8cb8","754":"f5e6e683"}[chunkId] + ".chunk.css";
};